import { useState } from 'react'
import { mintMcpToken, McpTokenResult } from 'api/oracleApi'

// Mutation hook for minting a per-user MCP bearer token. Follows the plain
// useState pattern used by the other Oracle hooks (no react-query in Gluon).
export function useMintMcpToken() {
    const [result, setResult] = useState<McpTokenResult | null>(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    const mint = async () => {
        setLoading(true)
        setError('')
        try {
            setResult(await mintMcpToken())
        } catch (e) {
            setError(e instanceof Error ? e.message : 'Failed to generate token')
        } finally {
            setLoading(false)
        }
    }

    const reset = () => {
        setResult(null)
        setError('')
    }

    return { result, loading, error, mint, reset }
}
